import { getAxiosClient } from './index';

export const getEmailExpired = (emailExpired: string) => {
    const restClient = getAxiosClient();
    return restClient.get(`/user/register-expired/${emailExpired}`);
};
